<template>
    <div class="header" :class="{collapse:collapse}">
        <!-- 折叠按钮 -->
        <div class="collapse-btn" @click="collapseChage">
            <i class="el-icon-menu"></i>
        </div>
		
        <div class="logo">门禁综合管理平台</div>
        <div class="header-right">
            <div class="header-user-con">
                <!-- 全屏显示 -->
                <div class="btn-fullscreen" @click="handleFullScreen">
                    <el-tooltip effect="dark" :content="fullscreen?`取消全屏`:`全屏`" placement="bottom">
                        <i class="el-icon-rank"></i>
                    </el-tooltip>
                </div>
                <!-- 用户头像 -->
                <!--<div class="user-avator" style="border-radius:50%;" v-if="!collapse"><img :src="headImage"></div>-->
				&nbsp;<el-tag size="large" type="success">{{ name }}</el-tag>&nbsp;
				<el-link type="primary" href="/#/changepwd">修改密码</el-link>&nbsp;
				<el-link type="primary" @click="loginout">退出登录</el-link>
            </div>
        </div>
    </div>
</template>
<script>
    import bus from '../common/bus';
    export default {
        data() {
            return {
                collapse: false,
                fullscreen: false,
                name: window.$gloable.userinfo.obj.name,
                headImage: window.$gloable.userinfo.obj.headimage,
                message: 2
            }
        },
        computed:{
            username(){
                let username = localStorage.getItem('ms_username');
                return username ? username : this.name;
            }
        },
        methods:{
            // 用户名下拉菜单选择事件
            handleCommand(command) {
                if(command == 'loginout'){
                    localStorage.removeItem('ms_uinfo');
                    window.$gloable.userinfo.obj = undefined;
                    //this.$router.push('/login');
                    location.href = 'api/user/logout?sign=' + window.$gloable.userinfo.sign;
                } else if (command == 'todo'){
					window.$gloable.tags.goPage('/todo');
                } else if(command == 'usercenter'){
					window.$gloable.tags.goPage('/ucenter');
				}
            },
			loginout() {
				localStorage.removeItem('ms_uinfo');
				window.$gloable.userinfo.obj = undefined;
				//this.$router.push('/login');
				location.href = 'api/user/logout?sign=' + window.$gloable.userinfo.sign;
			},
            // 侧边栏折叠
            collapseChage(){
                this.collapse = !this.collapse;
                bus.$emit('collapse', this.collapse);
            },
            // 全屏事件
            handleFullScreen(){
                let element = document.documentElement;
                if (this.fullscreen) {
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.webkitCancelFullScreen) {
                        document.webkitCancelFullScreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                    }
                } else {
                    if (element.requestFullscreen) {
                        element.requestFullscreen();
                    } else if (element.webkitRequestFullScreen) {
                        element.webkitRequestFullScreen();
                    } else if (element.mozRequestFullScreen) {
                        element.mozRequestFullScreen();
                    } else if (element.msRequestFullscreen) {
                        // IE11
                        element.msRequestFullscreen();
                    }
                }
                this.fullscreen = !this.fullscreen;
            }
        },
        mounted(){
            if(document.body.clientWidth < 1500){
                this.collapseChage();
            }
        }
    }
</script>
<style scoped>
    .header {
        position: relative;
        box-sizing: border-box;
        width: 100%;
        height: 70px;
        font-size: 22px;
        color: #fff;
    }
    .header.collapse {
        height:40px;
        transition: height 1s;
        -moz-transition: height 1s;
        -webkit-transition: height 1s;
        -o-transition: height 1s;
    }
    .header .collapse-btn{
        float: left;
        padding: 0 21px;
        cursor: pointer;
        line-height: 70px;
    }
    .header.collapse .collapse-btn{
        line-height: 40px;
    }
    .header .logo{
        float: left;
        width:250px;
        line-height: 70px;
    }
    .header.collapse .logo{
        line-height: 40px;
    }
    .header-right{
        float: right;
        padding-right: 50px;
    }
    .header .header-user-con{
        display: flex;
        height: 70px;
        align-items: center;
    }
    .header.collapse .header-user-con{
        height: 40px;
    }
    .btn-fullscreen{
        transform: rotate(45deg);
        margin-right: 5px;
        font-size: 24px;
    }
    .btn-bell, .btn-fullscreen{
        position: relative;
        width: 30px;
        height: 30px;
        text-align: center;
        border-radius: 15px;
        cursor: pointer;
    }
    .btn-bell-badge{
        position: absolute;
        right: 0;
        top: -2px;
        width: 8px;
        height: 8px;
        border-radius: 4px;
        background: #f56c6c;
        color: #fff;
    }
    .btn-bell .el-icon-bell{
        color: #fff;
    }
    .user-name{
        margin-left: 10px;
    }
    .user-avator{
        margin-left: 20px;
        background: #fff;
        opacity: 0.5;
    }
    .user-avator img{
        display: block;
        width:40px;
        height:40px;
        border-radius: 50% !important;
    }
    .el-dropdown-link{
        color: #fff;
        cursor: pointer;
    }
    .el-dropdown-menu__item{
        text-align: center;
    }
</style>
